module.exports = __webpack_public_path__ + "static/media/W18-0698_AW_350_Teen_Burger_mobile_hero_EN.41e5c922.jpg";